(function() {
'use strict';

angular
    .module('TR')
    .service('hotelSearch', hotelSearch);

function hotelSearch(
        loggingService,
        hotelFilterQueryStringParser,
        preferences,
        $routeParams,
        $http,
        roundedCurrencyFilter,
        arrayUtil,
        guidService,
        localStorageProvider,
        $q,
        cookieService,
        fieldGroupService,
        occupancyService,
        searchUnitService,
        destinationService,
        hotelSearchValidator,
        hotelService,
        FilterUtils,
        imageService,
        broker,
        $location,
        cancellerService,
        tripService,
        $timeout,
        sortCriteria,
        criteoService,
        FilterIdUtils,
        $rootScope,
        currentDestination,
        objectTypeService,
        resourceService,
        bd4travel,
        holidaySearch,
        analytics,
        abTest,
        fidParser,
        taxationService,
        flightDetail,
        analyticsTracker
    ) {
    const service = {
        pruneRequest,
        clearSearchResults,
        bitFilterSet,
        buildHotelsRequest,
        createSearch,
        filter,
        filterSet,
        getAvailabilityRequest,
        getDestinationEstabId,
        getDestinationTitle,
        getOccupancySummary,
        getFilter,
        getFilterLazy,
        getUserSelectedFilterCriteria,    //if ranges match aggregates they will be set to null - this will return a copy of the filter
        getSearchResults,
        getStaticSearchResults,
        getSortCriteria,
        getSortCriterionDescription,
        createMultiDestHolidaySearch,
        getTripForSelectedMultiDestHoliday,
        getPromotionTerms,
        getFlightDetailsForSelectedMultiDestHoliday,
        getUrl,
        initialise,
        page,
        pageSize,
        pageIndex,
        rangeFilterSet,
        removeArrayFilter,
        removeFiltersIn,
        removeFilter,
        resetArrayFilter,
        resetBitFilter,
        resetFilters,
        resetRangeFilter,
        setAirportCodeFilter,
        sort,
        validateSearchCriteria,
        updateFilterFromFid,
        estabGroupFilterAvailable,
        getMandatoryExtra
    };

    const domain = TRPCONFIG.Domain;
    let url = '/api/hotels/availability/';
    const staticUrl = '/api/hotels/static/';
    let results = null;
    let aggregatesCache;
    let inProgress;
    let inProgressStatic;
    let adjustingInProgress = $q.when();
    let canceller;
    let filterCanceller;
    let creatingSearch;
    const sortCriteriaDef = sortCriteria.getHotelCriteria();
    let filterUtil = new FilterUtils(_initialFilterCriteria());
    let filterDefer = $q.defer();
    const qs = $location.search();

    const usedIds = {};

    const req = {
        CultureCode: domain.CultureCode,
        DomainId: domain.DomainId,
        CurrencyCode: searchUnitService.getCurrency(),
        Paging: {
            Index: qs.pi || 0,
            Size: 8
        },
        IncludeAggregates: true
    };

    const fieldType = fieldGroupService.getFieldTypes();

    const availabilitySearchFlags = [
        fieldType.Global,
        fieldType.Titles,
        fieldType.ReviewSnippets,
        fieldType.Url,
        fieldType.Summary,
        fieldType.Pricing,
        fieldType.Recommendations,
        fieldType.EstabGroupIds,
        fieldType.HotelAwards,
        fieldType.RoomAvailability,
    ];
    const staticSearchFlags = [
        fieldType.Global,
        fieldType.Titles,
        fieldType.IndicativePrice,
        fieldType.ReviewSnippets,
        fieldType.Url,
        fieldType.Summary,
        fieldType.Recommendations,
        fieldType.EstabGroupIds,
        fieldType.HotelAwards
    ];

    broker.subscribe('hotelSearch', 'searchDatesAdjusted', ev => {
        if (canceller != null) {
            canceller.resolve('searchDatesAdjusted');
            inProgress = null;
            canceller = null;
        }
        rerun();

        function rerun() {
            service.clearSearchResults(true);
            if (filterCanceller) {
                filterCanceller.resolve();
            }
            adjustingInProgress = tripService.getHotelsRequest(ev.data.tripId).then(request => {
                holidaySearch.adjustHotelDates(request.AvailabilitySearchId, ev.data.dates).then(AvailabilitySearchId => {
                    service.buildHotelsRequest(_.defaults(
                        { AvailabilitySearchId },
                        ev.data.dates,
                        _.pick(request, ['CheckInDate', 'CheckOutDate', 'Destination'])
                    ), searchUnitService.flight);
                    tripService.recordHotelSearch(ev.data.tripId, getAvailabilityRequest());
                });
            });
        }
    });

    function _initialFilterCriteria() {
        return angular.extend(_defaultFilterCriteria(), hotelFilterQueryStringParser.parse());
    }

    function _setInProgress(val, stat) {
        if (stat) {
            inProgressStatic = val;
        } else {
            inProgress = val;
        }
    }

    function _setResults(val, stat) {
        if (!stat) {
            results = val;
        }
    }

    function estabGroupFilterAvailable() {
        return FilterIdUtils.estabGroupFilterAvailable(service.getFilter());
    }


    function updateFilterFromFid() {
        const fid = fidParser.parse();
        if (fid != null) {
            return FilterIdUtils.lookupFid(fid).then(function(f) {
                $rootScope.canonicalSuffix = f && f.Canonical ? `?fid=${fid}` : '';
                filterUtil = new FilterUtils(angular.extend(filterUtil.getFilter(), f));
            });
        }
        //no fid so nothing to do
        return $q.when();
    }

    function _defaultFilterCriteria() {
        const existing = filterUtil ? getFilter() : null;
        const newFilter = {
            AirportCode: null,
            Stars: [],
            PropertyTypes: [],
            BoardTypes: [],
            FacilityCodes: [],
            HotelName: '',
            PriceRange: null,
            HolidayPriceRange: null,
            RatingRange: null,
            EstabGroupIds: [],
            EstabGroupName: null,
            FilterByEstabGroup: false,
            ChildDestinations: [],
            OnlyShowAvailable: true
        };
        if (existing && existing.AirportCode) {
            newFilter.AirportCode = existing.AirportCode;
        }
        return newFilter;
    }

    function getUserSelectedFilterCriteria() {
        //when filtering we should only pass the items a user has set, but we also want to
        //take care to not modify the actual filter object, so return a modified
        //copy of the filter
        const filterCopy = angular.copy(getFilter());

        if (aggregatesCache != null) {
            filterUtil.setToNullIfMatches(filterCopy, 'PriceRange', aggregatesCache);
            filterUtil.setToNullIfMatches(filterCopy, 'HolidayPriceRange', aggregatesCache);
            filterUtil.setToNullIfMatches(filterCopy, 'RatingRange', aggregatesCache);
            results && results.SearchCompletePercentage < 100 && _.assignIn(filterCopy, {
                PriceRange: null,
                RatingRange: null,
                HolidayPriceRange: null
            });
        }

        //correctly set the estab group property of the copied filter also
        FilterIdUtils.updateEstabGroupProperties(filterCopy);

        return filterCopy;
    }

    function setAirportCodeFilter(code) {
        const f = getFilter();
        if (f.AirportCode !== code) {
            results = null;     //we will need to re-run the results to filter by the new airport code
        }
        f.AirportCode = code;
    }

    function mergeFacilitiesFilters(aggregates) {
        aggregates.MergedHotelsByFacility = {};
        for (const group in aggregates.HotelsByFacility) {
            angular.extend(aggregates.MergedHotelsByFacility, aggregates.HotelsByFacility[group]);
        }
        return aggregates;
    }

    function enrichData(hotels, currency, isKidsFree) {
        const kidsFreeEnabled = isKidsFree &&
            (parseInt(cookieService.get('KidsPromoAB')) === 1 || TRPCONFIG.Domain.isAgentMode);
        const numPeoplePaying = kidsFreeEnabled
            ? occupancyService.getOnlyPayingIndividuals()
            : occupancyService.getNumberOfNonInfantPassengers();
        angular.forEach(hotels, function(hotel) {
            const dim = TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize;
            hotel.ImageUrl = imageService.getMainImageUrl(hotel.Id, dim, dim, true);
            hotel.MinCostStr = roundedCurrencyFilter(hotel.MinCost, currency);
            hotel.MinCostPerPerson = hotel.MinCost / (numPeoplePaying || 1);
            hotel.MinCostPerPersonStr = roundedCurrencyFilter(hotel.MinCostPerPerson, currency);

            hotel.OriginalCostStr = roundedCurrencyFilter(hotel.OriginalCost, currency);
            hotel.OriginalCostPerPerson = hotel.OriginalCost / (numPeoplePaying || 1);
            hotel.OriginalCostPerPersonStr = roundedCurrencyFilter(hotel.OriginalCostPerPerson, currency);

            hotel.HasReviewSnippets = !_.isEmpty(hotel.ReviewSnippets);
            hotel.TeaserStr = roundedCurrencyFilter(hotel.IndicativeMinPrice);
        });
        broker.publish('hotelsReturnedFromSearch', hotels);
    }

    function setSortCriterion(d, k, newSearch, so) {
        if (so != null) {
            return $q.when(so);
        }

        if (k != null && d.EstablishmentId <= 0) {
            switch (k.toLowerCase()) {
                case 'tr':
                    return $q.when(2);
                case 'bh':
                    return $q.when(5);
                case 'lh':
                    return $q.when(8);
            }
        }
        return preferences.getHotelSortOrder(newSearch);
    }

    function resetFilters(dontApply) {
        const f = _defaultFilterCriteria();
        filterUtil = new FilterUtils(f);
        filterDefer = $q.defer();
        //make sure that when we resetAll filters we don't splat any estab group filter completely, just remove the ids
        FilterIdUtils.updateEstabGroupProperties(f);
        if (!dontApply) {
            return service.filter();
        }
        return $q.when();
    }

    function removeArrayFilter(filterName, item) {
        filterUtil.removeArrayFilter(filterName, item);
        return service.filter();
    }

    function resetArrayFilter(filterName) {
        filterUtil.resetArrayFilter(filterName);
        return service.filter();
    }

    function resetBitFilter(filterName) {
        filterUtil.resetBitFilter(filterName);
        return service.filter();
    }

    function removeFiltersIn(filterName, vals) {
        filterUtil.removeFiltersIn(filterName, vals);
        return service.filter();
    }

    function resetRangeFilter(filterName, range) {
        if (results != null) {
            let resetFrom = abTest.progressiveHotelSearchEnabled() ? null : results.Aggregates;
            filterUtil.resetRangeFilter(results, resetFrom, filterName, range);
        }
        return service.filter();
    }

    function removeFilter(filterName) {
        filterUtil.removeFilter(filterName);
        return service.filter();
    }

    function filterSet(filterName) {
        return filterUtil.filterSet(filterName);
    }

    function bitFilterSet(filterName) {
        return filterUtil.bitFilterSet(filterName);
    }

    function rangeFilterSet(filterName, range) {
        if (!results) { return false; }
        return filterUtil.rangeFilterSet(results, results.Aggregates, filterName, range);
    }

    function pageSize() {
        return req.Paging.Size;
    }

    // getter/setter
    function pageIndex(pi) {
        const key = 'hotelSearch-pageIndex';
        if (arguments.length === 0) {
            return localStorageProvider.getItem(key)
                .then(item => {
                    if (item && item.path === $location.path() && $location.search().disablePaging !== '1') {
                        return item.pi;
                    }
                    return parseInt(req.Paging.Index);
                });
        }
        req.Paging.Index = pi;
        return localStorageProvider.setItem(key, {
            path: $location.path(),
            pi,
        });
    }

    function validateSearchCriteria() {
        return hotelSearchValidator.validate(
            searchUnitService.getDestination(),
            searchUnitService.startDate(searchUnitService.hotel),
            searchUnitService.endDate(searchUnitService.hotel),
            searchUnitService.getSearchArea(searchUnitService.hotel),
            occupancyService.getOccupancy());
    }

    function getDestinationEstabId() {
        return currentDestination.getCurrentDestination().then(function(dest) {
            return dest &&
                dest.EstablishmentId
                    ? dest.EstablishmentId
                    : dest.Type === 1
                        ? dest.Id
                        : 0;
        });
    }

    function getDestinationTitle() {
        return currentDestination.getCurrentDestination().then(function(dest) {
            return dest ? dest.SummaryTitle : '';
        });
    }

    function getOccupancySummary() {
        return occupancyService.getRoomOccupancyString();
    }

    function _checkSearchId(r) {
        if (usedIds[r.AvailabilitySearchId]) {
            loggingService.logWarn(`DUPLICATESEARCHID: ${r.AvailabilitySearchId} has been used before`);
        } else {
            usedIds[r.AvailabilitySearchId] = true;
        }
    }

    function pruneRequest(r) {
        return _.assignIn(_.omit(r, 'Destination'), {
            Destination: _.pick(r.Destination, 'Id', 'Type'),
            StreamPrices: abTest.progressiveHotelSearchEnabled(true)
        });
    }

    function createSearch() {
        if (req.SearchArea) {
            req.SortCriterion = 4;
            creatingSearch = doSearch();
            return creatingSearch;
        }
        creatingSearch = setSortCriterion(req.Destination, $location.search().k, true, $location.search().sortOrder)
            .then(s => { req.SortCriterion = s; })
            .then(doSearch);

        return creatingSearch;

        function doSearch() {
            if (!TRPCONFIG.Domain.HotelAvailabilitySearchIdHashing) {
                _checkSearchId(req);
            }

            analyticsTracker.resetStatus(false);

            canceller = cancellerService.add(/^\/holidays\/flights\/\w+/, /^\/hotels\/\w+/, /^\/holidays\/hotels\/\w+/);

            const prunedReq = pruneRequest(req);

            return $http.post(`${url}createsearch`, prunedReq, { timeout: canceller.promise })
                .then(result => {
                    creatingSearch = null;
                    canceller = null;
                    broker.publish('hotelSearchCreated', req.AvailabilitySearchId);
                    req.AvailabilitySearchId = result && result.data;
                    tripService.recordHotelSearch(req.TripId, req);
                    return req.AvailabilitySearchId;
                }, function(res) {
                    inProgress = null;
                    canceller = null;
                    if (res.status === 400) {
                        $location.path('error');
                    }
                    if (res.status === 404) {
                        $location.path('hotels/notfound');
                    }
                });
        }
    }

    function buildHotelsRequest(request, mode) {
        req.AvailabilitySearchId = request && request.AvailabilitySearchId
            || !TRPCONFIG.Domain.HotelAvailabilitySearchIdHashing && guidService.uuid();
        req.Destination = _getDestination(request);
        req.TripId = request && request.TripId || guidService.uuid();
        req.Rooms = request && request.Rooms || occupancyService.getOccupancy();
        req.CurrencyCode = request && request.CurrencyCode || searchUnitService.getCurrency();
        req.CheckInDate = request && request.CheckInDate || searchUnitService.startDate(mode);
        req.CheckOutDate = request && request.CheckOutDate || searchUnitService.endDate(mode);
        req.Paging.Index = 0;
        req.SearchArea = searchUnitService.getSearchArea();
        req.IsFlightPlus = (request && request.IsFlightPlus);
    }

    function _getDestination(request) {
        const dest = request && request.Destination || searchUnitService.getDestination();

        return dest ? angular.extend(dest, objectTypeService.getObjectTypeAndId(dest)) : null;
    }

    function updateSortCriterion() {
        if (req.SortCriterion == null || !TRPCONFIG.IsMobileView) {
            return preferences.getHotelSortOrder().then(s => req.SortCriterion = s);
        }
        return $q.when();
    }

    function search(options) {
        options = angular.merge({
            fidCheck: false,
            stat: false,
            refreshRankingScores: false
        }, options);

        const currentInProgress = options.stat ? inProgressStatic : inProgress;
        if (currentInProgress != null) {
            return currentInProgress;
        }

        //TODO - now that we are paging the data we should add a cache of pages by availability Id so
        //that if we revisit a page we have already asked for we don't have to go to the server.
        //Must remember to clear the cache if the filter or sort criteria are changed.

        const start = new Date().getTime();
        const interval = 1000;
        const timeout = 60000;
        const d = $q.defer();
        const notfound = {
            410: errorPath,    //results are never going to arrive
            404() {
                const now = new Date().getTime();
                if (now - start < timeout) {
                    $timeout(get, interval);   //recurse
                    return true;    //to indicate that the error condition has been handled (for now)
                }
                errorPath();
            }
        };

        function errorPath() {
            const supportedProducts = TRPCONFIG.Domain.SupportedProductNames.map(p => p.toLowerCase());
            const hotelsPathSupported = supportedProducts.indexOf('hotels') > -1;

            _setInProgress(null, options.stat);
             hotelsPathSupported
                 ? $location.path('hotels/notfound')
                 : $location.path('holidays/notfound');

            d.reject();
        }

        _setInProgress(d.promise, options.stat);
        hotelFilterQueryStringParser.format(getUserSelectedFilterCriteria());
        if (!options.stat && creatingSearch != null) {
            return creatingSearch.then(get);
        }
        return updateSortCriterion().then(() => get(options.fidCheck));

        function get(fidCheck) {
            return $q.all([
                tripService.getCurrency($routeParams.tripId),
                currentDestination.getCurrentDestination(),
                tripService.isKidsFree($routeParams.tripId),
                tripService.getTrip($routeParams.tripId)
            ]).then(result => {
                const trip = result[3];
                const isMultiDestHoliday = Boolean(trip && trip.TripType === tripService.tripTypes.MultiDestHoliday);

                filterCanceller = cancellerService.add(/^\/holidays\/flights\/\w+/, /^\/hotels\/\w+/, /^\/holidays\/hotels\/\w+/);
                filterCanceller.promise.then(function() {
                    _setInProgress(null, options.stat);
                });
                if (result[1]) {
                    const objectTypeAndId = objectTypeService.getObjectTypeAndId(result[1]);
                    req.DestinationType = objectTypeAndId.Type;
                    req.DestinationId = objectTypeAndId.Id;

                    if ($location.search().bfd) {
                        req.DestinationType = 1;
                        req.DestinationId = $location.search().bfd;
                    }

                    if (result[1].PageStrand) {
                        req.PageStrand = result[1].PageStrand;
                    }
                }
                req.AllowIncompleteResults = abTest.progressiveHotelSearchEnabled();
                req.CurrencyCode = result[0] || TRPCONFIG.Domain.CurrencyCode;

                req.FieldFlags = fieldGroupService.getFieldGroup(req.AvailabilitySearchId && !options.stat ? availabilitySearchFlags : staticSearchFlags);

                req.DiscountCode = TRPCONFIG.DiscountCode;
                req.TripId = $routeParams.tripId;
                req.RefreshRankingScores = options.refreshRankingScores;
                req.EnableTracking = !analyticsTracker.isCounted() && analyticsTracker.isEnabled();
                req.AddMeetAndGreet = TRPCONFIG.Domain2.AddMeetAndGreet;

                let intermediateRes;
                pageIndex()
                    .then(pi => {
                        req.Paging.Index = pi;
                        const notStaticSearch = req.AvailabilitySearchId && !options.stat;
                        let _url;
                        if (isMultiDestHoliday) {
                            _url = '/api/holidays/getmultidestinationsearchresults';
                            req.PlacementId = 'jan-sale';
                        } else if (notStaticSearch) {
                            _url = `${url}gethotels`;
                        } else {
                            _url = `${staticUrl}gethotelsbydestination?fieldsX=Hotels.MinCost,Hotels.OriginalCost`;
                        }

                        let reqCopy = angular.copy(req);
                        if (notStaticSearch && qs.selectedEstabId) {
                            const selId = parseInt(qs.selectedEstabId);
                            if (!isNaN(selId)) {
                                reqCopy.SelectedEstabId = selId;
                            }
                        }
                        delete reqCopy.Destination;
                        _(reqCopy.FilterCriteria).forEach((value, key) => {
                            if (value == null || value === false || value.length === 0) {
                                delete reqCopy.FilterCriteria[key];
                            }
                        });

                        if (isMultiDestHoliday) {
                            // Airport Code filter from prev search causes no results
                            reqCopy.FilterCriteria = _.omit(reqCopy.FilterCriteria, 'AirportCode');
                        }

                        return $http.post(
                            _url,
                            reqCopy, {
                                timeout: filterCanceller.promise,
                                customErrCallback: notfound
                            });
                    }).then(
                        response => {
                            intermediateRes = response;
                            intermediateRes.data.Hotels = _.map(intermediateRes.data.Hotels, (hotel, i) => {
                            if (intermediateRes.data.Hotels && intermediateRes.data.Hotels[i].RequestedRooms && intermediateRes.data.Hotels[i].RequestedRooms[0].BoardTypeMinPrices) {
                                let taxObj = {
                                    TotalAmount: intermediateRes.data.Hotels[i].RequestedRooms[0].BoardTypeMinPrices[0].CityTax,
                                    CityTaxLocalAmount: intermediateRes.data.Hotels[i].RequestedRooms[0].BoardTypeMinPrices[0].CityTaxLocalAmount,
                                    CurrencyCode: intermediateRes.data.Hotels[i].RequestedRooms[0].BoardTypeMinPrices[0].CityTaxLocalCurrency
                                };
                                _.merge(hotel, { Taxation: taxObj });

                            }
                            analyticsTracker.resetStatus(false);
                            return hotel;
                        });
                        return intermediateRes;
                        },
                        () => intermediateRes
                        ).then(res => {
                        enrichData(res.data.Hotels, req.CurrencyCode, !!result[2]);
                        if (!options.stat && res.data.Aggregates) {
                            res.data.Aggregates = mergeFacilitiesFilters(res.data.Aggregates);
                            //PriceRange.Min will be having only multiples of 10.
                            res.data.Aggregates.LowestPricedHotel = res.data.Aggregates.PriceRange.Min;
                            res.data.Aggregates.PriceRange.Max = Math.ceil(res.data.Aggregates.PriceRange.Max / 10) * 10;
                            res.data.Aggregates.PriceRange.Min = Math.floor(res.data.Aggregates.PriceRange.Min / 10) * 10;
                            if (!abTest.progressiveHotelSearchEnabled() && !isMultiDestHoliday) {
                                filterUtil.copyFilterFrom('RatingRange', res.data.Aggregates);
                                filterUtil.copyFilterFrom('PriceRange', res.data.Aggregates);
                                filterUtil.copyFilterFrom('HolidayPriceRange', res.data.Aggregates);
                            }
                            //we don't currently allow filtering on each individual estab group, so squash the data
                            res.data.Aggregates.HotelsByGroup = FilterIdUtils.createEstabGroupOptions(res.data.Aggregates.HotelsByGroup);

                            //Add board type title to aggregates
                            addTitleToBoardTypes(res.data.Aggregates.HotelsByBoardType);
                        }
                        const currentResults = res.data;
                        _setResults(currentResults, options.stat);

                        //Save the aggregates in their own variable, so that they arn't lost when results is nulled out.
                        aggregatesCache = currentResults.Aggregates;
                        d.resolve(currentResults);

                        if (!currentResults.Hotels.length && fidCheck && !options.stat) {
                            const filteredFilter = FilterIdUtils.sanitiseFidFilters(angular.copy(filterUtil.getFilter()), angular.copy(currentResults.Aggregates), _defaultFilterCriteria());
                            if (filteredFilter) {
                                loggingService.logWarn(`Wrong filters in fid ${$location.search().fid}`);
                                filterUtil = new FilterUtils(filteredFilter);
                                req.FilterCriteria = getUserSelectedFilterCriteria();
                                return get();
                            }
                        }

                        const filterData = service.getFilter();
                        filterDefer.resolve(filterData);
                        currentResults.Filters = filterData;
                        currentResults.SortCriterion = sortCriteria.getHotelSortValueById(req.SortCriterion);
                        _setInProgress(null, options.stat);
                        broker.publish('hotelResultsModified', _.assign({}, currentResults, {
                            searchTriggeredBy: options.searchTriggeredBy
                        }));

                        if (!options.ignoreTracking) {
                            analytics.track('Event', 'HotelList', currentResults);
                            tripService.getTrip($routeParams.tripId)
                                .then(trip => {
                                    let tripType = trip && trip.TripType ||
                                        (_.get(searchUnitService.getDestination(), 'PageStrand') === 2 ? 4 : 2);
                                    criteoService.enqueue(currentResults, 'hotellist', tripType);
                                    bd4travel.trackHotelResults(trip, currentResults, req);
                                });
                        }

                        const noUserClicksRank = _.size(
                            _.filter(
                                _.get(currentResults, 'Hotels'),
                                h => _.get(h, 'UserClicksRank')
                            )
                        );
                        const noRecommended = _.size(
                            _.filter(
                                _.get(currentResults, 'Hotels'),
                                h => _.get(h, 'Recommended')
                            )
                        );
                        const familyFriendlyOffered = _.some(
                            _.get(currentResults, 'Hotels'),
                            h => _.includes(h.EstabGroupIds, TRPCONFIG.Domain.FamilyFriendlyEstabGroup)
                        );

                        const winnerOffered = _.some(
                            _.get(currentResults, 'Hotels'),
                            h => _.has(h, 'HotelAward')
                        );
                        setTimeout(() => {
                            analytics.track('mixpanel', 'HotelListing', {
                                RepeatHotelOffered: noUserClicksRank > 0,
                                TopDealsOffered: noRecommended > 0,
                                WinnerOffered: winnerOffered,
                                NoRepeatHotelsOffered: noUserClicksRank,
                                NoTopDealsOffered: noRecommended,
                                FamilyFavouriteOffered: familyFriendlyOffered,
                                IsKidsPromoEligible: !!result[2],
                                IsJanSale: isMultiDestHoliday,
                                estabIDArray: _.map(currentResults.Hotels, h => h.Id),
                                ppPriceArray: _.map(currentResults.Hotels, h => h.MinCostPerPerson),
                                TotalPriceArray: _.map(currentResults.Hotels, h => h.MinCost),
                                SearchID: $routeParams.tripId,
                            });
                        });
                    }, function() {
                        _setInProgress(null, options.stat);
                        return $q.reject();
                    });

                return options.stat ? inProgressStatic : inProgress;
            });
        }
    }

    function page(index) {
        return this.pageIndex(index)
            .then(() => {
                req.FilterCriteria = getUserSelectedFilterCriteria();
                return search();
            });
    }

    function sort(criterion) {
        broker.publish('searchCriteriaModified');
        req.FilterCriteria = getUserSelectedFilterCriteria();
        results = null;
        return preferences.setHotelSortOrder(criterion)
            .then(fidCheck => search({
                fidCheck,
                refreshRankingScores: true,
                searchTriggeredBy: 'sort'
            }));
    }

    function filter() {
        filterCanceller && filterCanceller.resolve();
        broker.publish('searchCriteriaModified');
        req.FilterCriteria = getUserSelectedFilterCriteria();
        _trackHotelName(_.get(req.FilterCriteria, 'HotelName'));
        results = null;
        return pageIndex(0)
            .then(() => search({
                refreshRankingScores: true,
                searchTriggeredBy: 'filter'
            }));
    }

    function initialise(baseUrl) {
        url = baseUrl;
    }

    function getAvailabilityRequest() {
        return req;
    }

    function getUrl() {
        return url;
    }

    function clearSearchResults(setDefaultCriteria, setPostsCountByCountryId) {
        const qs = $location.search();
        filterUtil = new FilterUtils(setDefaultCriteria ? _defaultFilterCriteria() : _initialFilterCriteria());
        filterDefer = $q.defer();
        req.Paging.Index = qs.pi || 0;
        req.Paging.Size = setPostsCountByCountryId ? 12 : 8;
        results = null;
        return this;
    }

    function getSearchResults(searchId, options) {
        const qs = $location.search();
        if (results && searchId === results.AvailabilitySearchId) {
            broker.publish('hotelResultsRetrieved', results);
            return $q.when(results);
        }
        //we don't want to clear filters at this point, but need to clear the page index and results
        req.Paging.Index = qs.pi || 0;
        results = null;
        if (creatingSearch == null) {
            req.AvailabilitySearchId = searchId;
        }
        req.FilterCriteria = getUserSelectedFilterCriteria();
        return adjustingInProgress.then(() => search({
            ignoreTracking: !!_.get(options, 'ignoreTracking'),
            refreshRankingScores: true
        }));
    }

    function getStaticSearchResults() {
        const qs = $location.search();
        //we don't want to clear filters at this point, but need to clear the page index and results
        req.Paging.Index = qs.pi || 0;
        return search({
            stat: true
        });
    }

    function createMultiDestHolidaySearch(basketId, variant) {
        const { Domain } = TRPCONFIG || {};
        return $http.post('/api/holidays/createjansalesearch', {
            BasketId: basketId,
            DomainId: Domain.DomainId,
            CultureCode: Domain.CultureCode,
            CurrencyCode: Domain.CurrencyCode,
            Variant: variant
        })
            .then(res => res && res.data);
    }

    function getTripForSelectedMultiDestHoliday(tripId, hotel) {
        return tripService.getTrip(tripId)
            .then(trip => {
                const linkedFlight = hotel.LinkedFlight;
                const flightsRequest = _.find(
                    trip.MultiDestinationFlightRequests,
                    r => r.AvailabilitySearchId === hotel.LinkedFlight.FlightSearchId
                );
                const newTripId = guidService.uuid();

                // Update trip with linked flight details
                flightsRequest.SelectedDepartureAirport = {
                    Code: linkedFlight.OutboundLeg.DepartureAirport
                };
                flightsRequest.SelectedDestinationAirport = {
                    Code: linkedFlight.InboundLeg.DepartureAirport
                };

                const newTrip = Object.assign(
                    trip,
                    { // Note that TripType is tripService.tripTypes.MultiDestHoliday
                        TripId: newTripId,
                        FlightsRequest: flightsRequest
                    });

                return destinationService.getDetails({ Id: hotel.Id, Type: 1 })
                    .then(dest => newTrip.HotelsRequest.Destination = dest)
                    .then(() => tripService.persist(newTripId, newTrip))
                    .then(() => newTripId);
        });
    }

    function getFlightDetailsForSelectedMultiDestHoliday(tripId, hotel) {
        const linkedFlight = hotel.LinkedFlight;

        return flightDetail.getFlightDetails(tripId, {
            AvailabilitySearchId: linkedFlight.FlightSearchId,
            FlightId: linkedFlight.FlightId,
            IncludeSeatPlan: TRPCONFIG.DeviceSettings.SeatPlanEnabled,
            MultiSector: false
        }).then(details => {
            const flight = details.Itinerary;
            if (flight) {
                flight.FlightId = linkedFlight.FlightId; // See holidaySearchCtrl.js
                flight.DetailsId = details.DetailsId;
                flight.isMultiDestHolidayLinked = true;
            }
            return flight;
        });
    }

    function getFilter() {
        return filterUtil.getFilter();
    }

    function getFilterLazy() {
        return filterDefer.promise;
    }

    function getSortCriteria() {
        return sortCriteriaDef;
    }

    function getSortCriterionDescription() {
        return preferences.getHotelSortOrder().then(function(so) {
            const i = arrayUtil.indexOf(sortCriteriaDef, function(c) {
                return c.val === so || (angular.isArray(c.val) && c.val.indexOf(so) !== -1);
            });
            return sortCriteriaDef[i].name();
        });
    }

    function addTitleToBoardTypes(boardTypes) {
        const boardTypeStrings = {
            1: 'ROOMONLY',
            2: 'BEDANDBREAKFAST',
            3: 'HALFBOARD',
            4: 'FULLBOARD',
            5: 'ALLINCLUSIVE',
            6: 'SELFCATERING',
        };

        for (const p in boardTypes) {
            boardTypes[p].Title = resourceService.getDeferred(boardTypeStrings[p])();
        }
    }

    function getPromotionTerms() {
        return $http.get(`/api/hotels/pricing/promotionterms?domainId=${TRPCONFIG.Domain.DomainId}`)
            .then(res => res.data);
    }

    function _trackHotelName(name) {
        if (name) {
            analytics.track('mixpanel', 'HotelNameFilter');
        }
    }

    function getMandatoryExtra(hotel) {
        let hasMandatoryExtras = false;
        if (domain.MandatoryExtrasEnabled) {
            if (hotel && hotel.RequestedRooms && hotel.RequestedRooms.length > 0) {
                hotel.RequestedRooms[0].BoardTypeMinPrices.map(room => {
                    let roomWithMandatoryExtras = room.IncludedExtras && room.IncludedExtras.find(el => el.ExtraTypeId === '2');
                    return roomWithMandatoryExtras ? hasMandatoryExtras = true : null;
                });
            }
        }
        return hasMandatoryExtras;
    }

    return service;
}
})();
